module.exports = __webpack_public_path__ + "static/media/print.5e2e2c88.svg";